import VacationUserArchive from 'features/vacations/vacationUserArchive';
import { useTitle } from '../helpers';

/**
 * @page Vacations user page
 */
const VacationsUserArchivePage = () => {
  useTitle('Информация о заявлении в архиве');

  return (
    <div>
      <h3>Информация о заявлении в архиве</h3>
      <VacationUserArchive />
    </div>
  );
};

export default VacationsUserArchivePage;
